import { BrowserCookieStickyBucketService, GrowthBook } from '@growthbook/growthbook-react';
import { autoAttributesPlugin } from '@growthbook/growthbook/plugins';
import { segment } from '@/lib/analytics/segment';
import Cookies from 'js-cookie';

const growthbook = new GrowthBook({
  apiHost: import.meta.env.DEV
    ? `${window.location.origin}/growthbook-api`
    : 'https://cdn.growthbook.io',
  clientKey:import.meta.env['VITE_GROWTHBOOK_CLIENT_KEY'] || '',
  decryptionKey: import.meta.env['VITE_GROWTHBOOK_DECRYPTION_KEY'] || '',
  enableDevMode: true,
  stickyBucketService: new BrowserCookieStickyBucketService({
    jsCookie: Cookies,
  }),
  plugins: [autoAttributesPlugin()],
  trackingCallback: (experiment, result) => {
    const attrs = growthbook.getAttributes();

    // Skip tracking for users excluded from experiments
    if (attrs['excluded_from_experiments']) {
      return;
    }

    segment.track('Experiment Viewed', {
      experimentId: experiment.key,
      variationId: result.key,
      user_id: attrs['user_id'],
      path: attrs['path'],
    });
  },
});

// Initialize GrowthBook immediately
growthbook.init({ streaming: true });

export default growthbook;
